import { ApiErrorResponse } from "@/types";
import { AxiosError } from "axios";
import { toastError } from "./toastify";

export const toastApiError = (err?: AxiosError<ApiErrorResponse>) => {
  if (!err) return;
  const message = err.response?.data.message || err.message || "エラー";
  return toastError(message);
};
